import { DealFlag } from 'app/models/dto/team-deal';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DealFlagActions {

  export class Get {
    static readonly type = '[DealFlag] Get';
    constructor(public id: number) {}
  }

  export class GetIndex {
    static readonly type = '[DealFlag] GetIndex';
    constructor() {}
  }

  export class Create {
    static readonly type = '[DealFlag] Create';
    constructor(public entity: DealFlag) {}
  }

  export class Update {
    static readonly type = '[DealFlag] Update';
    constructor(public entity: DealFlag) {}
  }

  export class Delete {
    static readonly type = '[DealFlag] Delete';
    constructor(public id: number) {}
  }
}
